import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import * as _ from 'lodash';
import { catchError, map, switchMap } from 'rxjs/operators';

import { CustomerChallengeGenerateActions } from '../actions';
import { OnboardingProductsService } from '../../services/onboarding-products.service';
import { Common } from './common';
import { of } from 'rxjs';
import { Store } from '@ngrx/store';
import { OnboardingProductsStore } from '../store';

@Injectable()
export class CustomerChallengeGenerateEffects {
  constructor(
    private actions$: Actions,
    private onboardingProductsService: OnboardingProductsService,
    private store: Store<OnboardingProductsStore.AppState>
  ) {}

  private common = new Common();

  getCustomerChallengeGenerate$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CustomerChallengeGenerateActions.getCustomerChallengeGenerate),
      switchMap((action) =>
        this.onboardingProductsService.getCustomerChallengeGenerate(action.request).pipe(
          map((res) => this.responseInterpreter(res)),
          map((res) => res['middleware']),
          map((res) =>
            CustomerChallengeGenerateActions.getCustomerChallengeGenerateSuccess({ response: res })
          ),
          catchError((error) =>
            of(
              CustomerChallengeGenerateActions.getCustomerChallengeGenerateError({
                payload: this.common.handleErrorsDefault(error)
              })
            )
          )
        )
      )
    )
  );

  responseInterpreter(res) {
    console.log('******** ResponseInterpreter Input', res);
    res = res['response'];
    const response = res;
    if (
      _.get(res, 'status.code', '') === 200 ||
      _.get(res, 'status.code', '') === 202
    ) {
      if (_.get(res, 'middleware', null)) {
        response['middleware'] = _.get(res, 'middleware.data', null);
      }
    }
    console.log('******** ResponseInterpreter Return', response);
    return response;
  }
}
